export default __webpack_public_path__ + "static/media/defAvatar.ed9aaca9.jpg";